import PropTypes from 'prop-types';
import {TableFilterRow} from '@devexpress/dx-react-grid-material-ui';
import {useCallback, useMemo} from 'react';
import {useStyles} from 'Utility/styles';

export default function EntityFilterCell(props) {
  const {
    filter,
    onFilter,
    SelectEntity,
    message,
    getValueIdentifier,
    style,
    ...restProps
  } = props;
  const classes = useStyles();
  const getMessage = () => message;
  const value = useMemo(
    () => (getValueIdentifier ? undefined : filter ? filter.value : null),
    [filter, getValueIdentifier],
  );
  const selectValue = useMemo(
    () =>
      getValueIdentifier
        ? filter
          ? (object) => getValueIdentifier(object) === filter.value
          : null
        : undefined,
    [filter, getValueIdentifier],
  );
  const handleChange = useCallback(
    (value) =>
      onFilter(
        value
          ? getValueIdentifier
            ? {value: getValueIdentifier(value)}
            : {value}
          : null,
      ),

    [getValueIdentifier, onFilter],
  );

  return (
    <TableFilterRow.Cell
      getMessage={getMessage}
      className={classes.customFilterCell}
    >
      <SelectEntity
        className={classes.spacer}
        value={value}
        selectValue={selectValue}
        onChange={handleChange}
        label=""
        placeholder="Filter..."
        fullWidth
        variant="standard"
        style={style}
        {...restProps}
      />
    </TableFilterRow.Cell>
  );
}

EntityFilterCell.propTypes = {
  filter: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.shape({
        id: PropTypes.string,
      }),
      PropTypes.string,
    ]),
  }),
  message: PropTypes.string,
  onFilter: PropTypes.func.isRequired,
  SelectEntity: PropTypes.func.isRequired,
  getValueIdentifier: PropTypes.func,
  style: PropTypes.object,
};

EntityFilterCell.defaultProps = {
  message: '',
  getValueIdentifier: undefined,
  style: null,
};
